
export default (that, isShowLaborPrice) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_workLogTime') || '报工日期	',
    field: 'workLogTime',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'status',
    minWidth: 80,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: '员工工号',
    field: 'userNo',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '员工姓名',
    field: 'userName',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_workShiftName') || '班次',
    field: 'workShiftName',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_processName') || '工序',
    field: 'processName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_techName') || '工艺名称',
    field: 'techName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_laborPrice') || '工价',
    field: 'laborPrice',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    visible: isShowLaborPrice == 'Y'
  },
  {
    title: that.$l('table_label_reportedWorkQty') || '报工数量',
    field: 'reportedWorkQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techChargeUnit') || '数量单位',
    field: 'techChargeUnitText',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_title_totalActualTime') || '实际耗时(秒)',
    field: 'totalActualTimeSeconds',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_breakDuration') || '中断时长(分钟)',
    field: 'breakDuration',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_theoreticalTimeSeconds') || '理论耗时(秒)',
    field: 'theoreticalTimeSeconds',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_theoreticalQty') || '理论数量',
    field: 'theoreticalQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deviationQty') || '偏差数量',
    field: 'deviationQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'deviationQty' },
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goodsColor') || '产品颜色',
    field: 'goodsColor',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_spec') || '产品规格',
    field: 'spec',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'deviationSpec' },
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_categoryFullName') || '产品分类',
    field: 'categoryFullName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  }
]
